var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CommitVue',{ref:"childComponent",attrs:{"mystatus":_vm.mystatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }